import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Column, SortDirection } from '@shared/models';

export interface SortChange {
  sortBy: string;
  sortDirection: SortDirection;
}

@Component({
  selector: 'gcc-grid-sorting',
  templateUrl: './grid-sorting.component.html',
  styleUrls: ['./grid-sorting.component.scss']
})
export class GridSortingComponent implements OnInit {
  @Input() public column: Column.GridColumn;
  @Input() public sortDirection: SortDirection;
  @Input() public isActive: boolean;

  @Output() public sortChange: EventEmitter<SortChange> = new EventEmitter();

  public options;
  constructor() {}

  public ngOnInit() {
    this.options = [
      {
        icon: 'icon-table-sort-a-z',
        title: this.column.sortTitles[SortDirection.Ascending],
        value: SortDirection.Ascending
      },
      {
        icon: 'icon-table-sort-a-z icon-rotate-180',
        title: this.column.sortTitles[SortDirection.Descending],
        value: SortDirection.Descending
      }
    ];
  }

  public onSort(direction: SortDirection) {
    this.sortChange.next({ sortBy: this.column.name, sortDirection: direction });
  }
}
